// extracted by mini-css-extract-plugin
export default {"rating":"mG-z","numberOfStars":"nG-z","count":"oG-z","barGraphSpacing":"pG-z","barGraph":"qG-z"};